// src/stores/auth.js
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { ElMessage } from 'element-plus'
import router from '@/router'
import request from '@/utils/axios'   // ← 只保留 request

export const useAuthStore = defineStore('auth', () => {
  const user = ref(null)
  const isLoggedIn = ref(false)
  const loading = ref(false)

  // 严格遵守 v2.0 数据提取规范
  const handleResponse = (res) => res?.data || res || (Array.isArray(res) ? res : null)

  // 登录
  const login = async (email, password) => {
    loading.value = true
    try {
      const res = await request.post('/auth/jwt/create/', { email, password })
      const data = handleResponse(res)

      localStorage.setItem('access_token', data.access)
      localStorage.setItem('refresh_token', data.refresh)

      await fetchCurrentUser()

      isLoggedIn.value = true

      const lastPath = localStorage.getItem('lastVisitedPath') || '/'
      localStorage.removeItem('lastVisitedPath')
      router.push(lastPath === '/login' ? '/' : lastPath)

      return true
    } catch (error) {
      return false
    } finally {
      loading.value = false
    }
  }

  // 获取当前用户信息
  const fetchCurrentUser = async () => {
    try {
      const res = await request.get('/auth/users/me/')
      const data = handleResponse(res)
      user.value = data
      isLoggedIn.value = true
    } catch (error) {
      logout()
    }
  }

  // 登出
  const logout = async () => {
    try {
      const refreshToken = localStorage.getItem('refresh_token')
      if (refreshToken) {
        await request.post('/auth/jwt/blacklist/', { refresh: refreshToken })
      }
    } catch (e) {}
    
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
    user.value = null
    isLoggedIn.value = false
    ElMessage.warning('已退出登录')
    router.push('/login')
  }

  // 初始化
  const initAuth = async () => {
    const token = localStorage.getItem('access_token')
    if (token) {
      await fetchCurrentUser()
    }
  }

  // 角色徽章（v1.3 最终版）
  const roleBadge = computed(() => {
    const role = user.value?.role?.toLowerCase()?.trim() || 'default'
    const map = {
      admin:     { label: '管理员',     type: 'danger',   color: '#f56c6c' },
      manager:   { label: '操盘手',     type: 'primary',  color: '#409eff' },
      operation: { label: '数据忍者',   type: 'warning',  color: '#e6a23c' },
      staff:     { label: '观察员',     type: 'success',  color: '#67c23a' },
      default:   { label: '观察员',     type: 'info',     color: '#909399' }
    }
    return map[role] || map.default
  })

  return {
    user,
    isLoggedIn,
    loading,
    login,
    logout,
    fetchCurrentUser,
    initAuth,
    roleBadge
  }
})